module.exports = __webpack_public_path__ + "img/pic6.7c21b445.png";